import {createSelector} from 'reselect';

const getRoot = state => state;
const getState = createSelector(getRoot, state => state.fetchInterventions);
export const getInterventions = createSelector(getState, ({interventions}) => interventions);
export const isLoadingInterventions = createSelector(getState, ({loading}) => loading);
export const isShowingArchived = createSelector(getState, ({showArchived}) => showArchived);
export const pagination = createSelector(getState, ({pagination}) => pagination);
export const initPagination = createSelector(getState, ({initPagination}) => initPagination);
export const getFilters = createSelector(getState, ({filters}) => filters);
export const getInitFilters = createSelector(getState, ({initFilters}) => initFilters);
export const appliedFilters = createSelector(getState, ({appliedFilters}) => appliedFilters);
export const getFiltersCounters = createSelector(getState, ({counters}) => counters);



// WEBPACK FOOTER //
// ./src/selectors/fetchInterventions.js